<template>
    <div class="formkit-file-wrapper">


      <div class="formkit-file-input">
        <input 
          type="file"
          :id="context.id"
          :name="context.node.name"
          @change="handleFileChange"
          :accept="context.attrs.accept"
          class="formkit-input"
          :multiple="context.attrs.multiple"
          :disabled="!context.attrs.multiple && hasExistingFiles()"
        />
        
        <div v-if="getNewFileNames()" v-for="fileName in getNewFileNames()" class="formkit-file-selected">
          <span class="file-name">{{ fileName }}</span>
          <button 
            type="button" 
            @click="clearFile" 
            class="file-clear-btn"
          >
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
      </div>

            <!-- Show existing file if present -->
      <div v-if="hasExistingFiles()" v-for="file in getExistingFiles()" class="formkit-file-existing">
        <div class="file-name">
          <i class="fa-solid" :class="getFileIconClass(file)"></i>
          <span
            class="file-name-text"
            @click="downloadFile(file)"
            :class="{
                markedForDeletion: file.markedForDeletion,
                'cursor': !file.markedForDeletion && file.file_identifier 
            }"
            >
            {{ file.filename }}

            
        </span>
          
          <template v-if="file.file_identifier">
              
              <i v-if="!file.markedForDeletion" @click="markForDeletion(file)" class="fa-file-action fa-solid fa-trash-can"></i>
              <i v-else @click="unmarkForDeletion(file)" class="fa-file-action fa-solid fa-rotate-left"></i>
        </template>
        <i v-else @click="markForDeletion(file)" class="fa-file-action fa-solid fa-trash-can"></i>
        </div>

      </div>
      

    </div>
</template>


<script>
// extend default text input

export default {
    
    props: {
        context: {
            type: Object,
            required: true
        },
    },
    methods: {
        async downloadFile(file) {
            console.log('downloadFile', file)
            const res = await this.callApi('post', '/files/getAttachmentDownloadToken', file);
            console.log('downloadFile res', res)
            if (res.data.result.token) {
                window.open(process.env.VUE_APP_API_BASE + '/files/downloadAttachmentFile/' + res.data.result.token, '_blank');
            }

            // if (file.file_identifier) {
            //     window.open(process.env.VUE_APP_API_BASE + '/uploads/' + file.file_identifier, '_blank');
            // }
        },
        getFileIconClass(file) {
            if (!file.file_identifier && !file.markedForDeletion) return 'fa-solid fa-file-circle-plus success-color';
            else if (file.markedForDeletion) return 'fa-solid fa-file-circle-minus error-color';
            return 'fa-solid fa-file';
        },
        markForDeletion(file) {
            if (!file.file_identifier) {
                // remove from list
                //this.context._value = this.context._value.filter(f => f.name !== file.name);
                file.markedForDeletion = true;
                return;
            }
            this.confirmDialog(this.translate('general.file_delete_file_title'), this.translate('general.file_delete_file_text'), () => {
                file.markedForDeletion = true;
            });
        },
        unmarkForDeletion(file) {
            //this.confirmDialog('Herstellen', 'Weet je zeker dat je dit bestand wil herstellen?', () => {
                file.markedForDeletion = false;
            //});
        },
        handleFileChange(e) {
            console.log('handleFileChange', e.target.files)
            const file = e.target.files[0]
            if (file) {
                let a = this.context._value;
                
                // loop through filelist e.target.files
                for (let i = 0; i < e.target.files.length; i++) {
                    const f = e.target.files[i];
                    a.push({filename:f.name, file:f})
                }

                // add to

                this.context.node.input(a)
            }
        },
        clearFile() {
            this.context.node.input(null)
        },
        // Check if there's an existing file (from database)
        hasExistingFiles() {
            //console.log('hasExistingFiles', this.context._value)
            const value = this.context._value;
            if (!value || !Array.isArray(value) || value.length == 0) return false;
            return true;
        },
        // Get existing file name from database
        getExistingFiles() {
            const value = this.context._value;
            if (this.hasExistingFiles()) {
                console.log('getExistingFileName', value)
                return value;
                return value.map(f => f.name);
            }
            return null;
        },
        // Get existing file download URL
        getExistingFileUrl() {
            const value = this.context._value;
            if (this.hasExistingFiles()) {
                return process.env.VUE_APP_API_BASE + '/uploads/' + value.file;
            }
            return null;
        },
        // Get newly uploaded file name
        getNewFileNames() {
            const value = this.context._value;
            // Check if it's a newly uploaded File object
            if (value && value instanceof File) {
                return value.name;
            }
            return null;
        }
    },
    mounted() {
        //console.log('File component mounted', this.$props.context.value, this.$props.context._value)
    },
}
</script>

<style scoped>
.formkit-file-existing {
    /* border: 1px solid var(--input-field-line-color); */
    width: 100%;
    padding: 0.5rem 1.8rem;
    /* background: var(--cell-bg-color); */
    color: var(--base-color-1);
    border-radius: 10px;
    font-size: 1.4rem;
    font-family: var(--font-family-regular);
    line-height: var(--standard-text-line-height);
    outline: none;
    margin-top: 1rem;
}

.formkit-file-existing a {
    color: var(--base-color-1);
    text-decoration: none;
    font-size: 1.4rem;
    font-family: var(--font-family-regular);
    line-height: var(--standard-text-line-height);
    outline: none;
    margin-top: 1rem;
    float: right;
}
.file-name-text {
    margin-left: 1rem;
}
.file-clear-btn, .fa-file-action  {
    float: right;
    cursor: pointer;
}
.markedForDeletion {
    /* color: var(--alert-color-1); */
    text-decoration: line-through;
}
.error-color {
    color: var(--error-color);
}
.success-color {
    color: var(--success-color);
}
</style>

